import DefaultView from './brand-cloud.default'
import merge from 'lodash/merge'
import useBcSelectedStore from '@/frontapp/store/bcSelected'
import { mapStores } from 'pinia'

export default merge({
  computed: {
    ...mapStores(useBcSelectedStore),
  },
  mounted() {
    if (this.$el.id !== 'snippet--app') {
      return
    }

    this.bcSelectedStore.reset(null, '_id', null, false)
  },
}, DefaultView)
